export default class ConversationDepartmentModel {
  id!: number;

  nome!: string;

  ativo!: number;
}
